import { QRCodeCanvas } from "qrcode.react";
import styles from "./QrCode.module.css";
import { Skeleton, Typography } from "@mui/material";

type CoreQrCodeProps = {
	description?: string;
	qrCodeUrl?: string;
	ariaLabel: string;
	/**@default 350px */
	width?: number;
	/**@default 220px */
	height?: number;
	/**Size of the corner accents. @default 24px */
	qrCornerSize?: number;
};

export default function CoreQrCode({
	description,
	qrCodeUrl,
	ariaLabel,
	width = 350,
	height = 220,
	qrCornerSize = 24,
}: CoreQrCodeProps) {
	const containerWidth = width + 25;
	const containerHeight = height + 25;

	const qrCornerStyle = {
		width: qrCornerSize,
		height: qrCornerSize,
	};

	const borderWidth = qrCornerSize / 3;

	return (
		<div className={styles.qrWrapper}>
			<div className={styles.qrContainer} style={{ width: containerWidth, height: containerHeight }}>
				<div
					className={styles.qrCornerTopLeft}
					style={{
						...qrCornerStyle,
						borderTopWidth: borderWidth,
						borderLeftWidth: borderWidth,
						borderTopLeftRadius: borderWidth,
					}}
				/>
				<div
					className={styles.qrCornerTopRight}
					style={{
						...qrCornerStyle,
						borderTopWidth: borderWidth,
						borderRightWidth: borderWidth,
						borderTopRightRadius: borderWidth,
					}}
				/>
				<div
					className={styles.qrCornerBottomLeft}
					style={{
						...qrCornerStyle,
						borderBottomWidth: borderWidth,
						borderLeftWidth: borderWidth,
						borderBottomLeftRadius: borderWidth,
					}}
				/>
				<div
					className={styles.qrCornerBottomRight}
					style={{
						...qrCornerStyle,
						borderBottomWidth: borderWidth,
						borderRightWidth: borderWidth,
						borderBottomRightRadius: borderWidth,
					}}
				/>
				{qrCodeUrl ? (
					<QRCodeCanvas value={qrCodeUrl} level="M" style={{ width, height }} aria-label={ariaLabel} />
				) : (
					<Skeleton variant="rounded" animation="pulse" component="div" width={width} height={height} />
				)}
			</div>
			{description && <Typography className={styles.description}>{description}</Typography>}
		</div>
	);
}
